import getEnv from "./getEnv";

const bucket = () => {
    const env = getEnv(window.location);
    if (env === "production") return "volley-production-media";
    if (env === "rc") return "volley-rc-media";
    return "volley-staging-media";
};

export default (fileName: string) =>
    `https://storage.googleapis.com/${bucket()}/${fileName}`;
